import { EditionType } from '@graphics/gfx-common/dist/constants'
import { ICapabilitiesSummary } from '../types/capabilitiesSummary'
import { IEditionMetadata } from '../types/pack'
import { splitFileNameExt } from './file'

const emptyCapabilitiesSummary: ICapabilitiesSummary = {
  editionTypes: [],
  maxFileSizeMb: 0,
  allowedExtensions: [],
}

export interface IGetAllowedCapability {
  showFileZone: boolean
  showDataChartForm: boolean
  showDataFile: boolean
  showPasteImageFieldForPack: boolean
}

export const getAllowedCapability = ({
  editionTypes,
  allowedExtensions,
}: ICapabilitiesSummary = emptyCapabilitiesSummary): IGetAllowedCapability => ({
  showFileZone: !!(
    editionTypes.includes(EditionType.GraphicFolder) ||
    editionTypes.includes(EditionType.GraphicFile)
  ),
  showDataChartForm: !!editionTypes.includes(EditionType.DataStreamGraphic),
  showDataFile: !!editionTypes.includes(EditionType.DataStreamData),
  showPasteImageFieldForPack:
    !!editionTypes.includes(EditionType.GraphicFile) &&
    allowedExtensions.includes('.png'),
})

export const showPasteImageFieldForEdition = (
  edition: IEditionMetadata
): boolean =>
  edition.editionType === EditionType.GraphicFile &&
  ['png', 'jpg', 'jpeg'].includes(
    splitFileNameExt(edition.file.fileName).extension.toLowerCase()
  )
